export default __webpack_public_path__ + "static/media/kitakyushu_logo.0d904210.png";